export const MenuList = {
  dashboard: [
    {
      label: 'Content Collection',
      path: '/dashboard/content-collection',
      menuId: 'content-collection',
    },
    {
      label: 'Content Creation',
      path: '/dashboard/content-creation',
      menuId: 'content-creation',
      subMenu: [
        {
          label: 'Pre Final File',
          path: '/dashboard/content-creation/pre-final-file',
          menuId: 'pre-final-file',
        },
        {
          label: 'Final File',
          path: '/dashboard/content-creation/final-file',
          menuId: 'final-file',
        },
      ],
    },
    {
      label: 'Content Marketing',
      path: '/dashboard/content-marketing',
      menuId: 'content-marketing',
    },
    {
      label: 'Marketing Analytics',
      path: '/dashboard/content-marketing/analytics',
      menuId: 'marketing-analytics',
    },
  ],
  theme: [
    {
      menuId: 'topic',
      label: 'Topic',
      path: '/topic',
    },
    {
      menuId: 'sub-topic',
      label: 'Sub-Topic',
      path: '/sub-topic',
    },
  ],
  tags: [
    {
      menuId: 'brand',
      label: 'Brand',
      path: '/brands',
    },
    {
      menuId: 'person',
      label: 'Person',
      path: '/persons',
    },
    {
      menuId: 'identity',
      label: 'Identity',
      path: '/identities',
    },
    {
      menuId: 'location',
      label: 'Location',
      path: '/locations',
    },
    {
      menuId: 'event',
      label: 'Event',
      path: '/events',
    },
    {
      menuId: 'author',
      label: 'Author',
      path: '/authors',
    },
  ],
  contentTypes: [
    {
      menuId: 'vlog',
      label: 'Vlog',
      path: '/vlog',
    },
    {
      menuId: 'article',
      label: 'Article',
      path: '/article',
    },
    {
      menuId: 'video',
      label: 'Video',
      path: '/video',
    },
    {
      menuId: 'blog',
      label: 'Blog',
      path: '/blog',
    },
    {
      menuId: 'quote',
      label: 'Quote',
      path: '/quote',
    },
    {
      menuId: 'post',
      label: 'Post',
      path: '/post',
    },
    {
      menuId: 'book',
      label: 'Book',
      path: '/book',
    },
  ],
  marketingPlatform: [
    {
      menuId: 'youtube',
      label: 'Youtube',
      path: '/youtube',
    },
    {
      menuId: 'facebook',
      label: 'Facebook',
      path: '/facebook',
    },
    {
      menuId: 'instagram',
      label: 'Instagram',
      path: '/instagram',
    },
    {
      menuId: 'linkedIn',
      label: 'LinkedIn',
      path: '/linkedin',
    },
    {
      menuId: 'twitter',
      label: 'Twitter',
      path: '/twitter',
    },
  ],
  frontEndAnalytics: [
    {
      menuId: 'website',
      label: 'Website',
      path: '/website',
    },
    {
      menuId: 'appAnalytics',
      label: 'App Analytics',
      path: '/app-analytics',
    },
  ],
  profile: [
    {
      menuId: 'adminConsole',
      label: 'Admin Console',
      path: '/admin-console',
    },
    {
      menuId: 'editProfile',
      label: 'Edit Profile',
      path: '/edit-profile',
    },
    {
      menuId: 'logout',
      label: 'Logout',
      path: '/logout',
    },
  ],
};
